import { action, observable } from 'mobx'
import moment from 'moment'
import {
  createExcelFetchHandler,
  createDistrictExcelFetchHandler,
  getAddressInfoFetchHandler,
  newGetAddressInfoFetchHandler,
  getAreaCleanerceInfoFetchHandler,
  dateDetailsGetAreaCleanerceInfo,//数据明细中点击input筛选当前数据
  getIsExistExcel,
} from '../utils/fetchData'

import lang from '../i18n/index'

import GlobalControlStore from './GlobalControlStore'
import UserInfoStore from './UserInfoStore'

/*
    oneDayAgo:近十一天数据截止日期
    elevenDaysAgo：近十一天数据开始日期
    addressArr：存级联地址
    currentPage:当前页数
    timesArr:时间arr
    areaArr:所选区域数据
    totalPage:总页数
*/
class Store {
  @observable oneDayAgo = null
  @observable elevenDaysAgo = null
  @observable addressArr = []
  @observable choseAddress = ['全部']
  @observable regionId = ''
  @observable exportChoseAddress = ['全部']
  @observable exportMonthIsOpen = false
  @observable exportMonthTime = [moment('2019-1', 'YYYY-MM-DD'), moment()]
  @observable exportDateTime = [moment(), moment()]
  @observable exportChoseCanSure = false
  @observable totalPage = 1
  @observable currentPage = 1
  @observable pageSize = 10
  @observable timesArr = []
  @observable areaArr = []
  @observable showChoseReport = false
  @observable isDailyReport = true
  @observable showExportRange = false
  @observable exportDataName = null
  @observable progressNum = 0
  @observable progressIsShow = false
  @observable exportTipsShow = false
  @observable exportDataSuceess = true
  @observable exportTipsTxt = '文件创建成功，您可以点击下载按钮来下载文件。'
  @observable intervalTime = null
  @observable getAddressRole = ''
  @observable exportChoseAddressId = ''

  @action.bound
  async fetchDataDetailData() {
    try {
      let getAddressInfoFetchHandlerFin
      if (UserInfoStore.accountUseNewRules) {
        getAddressInfoFetchHandlerFin = newGetAddressInfoFetchHandler()
      } else {
        getAddressInfoFetchHandlerFin = getAddressInfoFetchHandler()
      }
      let [addressRes] = await Promise.all([getAddressInfoFetchHandlerFin])
      if (addressRes.ok) {
        const resBody = await addressRes.json()
        this.fetchAddressSuccess(resBody)
      }
    } catch (e) { }
  }
  @action fetchAddressSuccess(data) {
    GlobalControlStore.showLoading = false
    let res = UserInfoStore.accountUseNewRules ? data.content.results : data.content.provinces
    let resultArr = res.map(function (province) {
      let cities = UserInfoStore.accountUseNewRules ? province.subordinates : province.cities
      if (cities) {
        // 城市级
        cities = cities.map(function (city) {
          let districts = UserInfoStore.accountUseNewRules ? city.subordinates : city.districts
          if (districts) {
            districts = districts.map(function (district) {
              let towns = []
              if (UserInfoStore.accountUseNewRules && district.subordinates) {
                towns = district.subordinates.map((town) => ({
                    value: town.name,
                    label: town.name,
                    id: town.id,
                    roleValue: 'COMMUNITY',
                 })
                )
              }
              let districtObj = {
                value: district.name,
                label: district.name,
                id:district.id,
                roleValue:'TOWNSHIP',
                children:towns.length?towns:undefined,
              }
              return districtObj
            })
          }
          let cityObj = {
            value: city.name,
            label: city.name,
            id:city.id,
            roleValue:'COUNTY',
            children: districts,
          }
          return cityObj
        })
      }
      let obj = {
        value: province.name,
        label: province.name,
        id:province.id,
        roleValue:'PREFECTURAL',
        children: cities,
      }
      return obj
    })
    resultArr.unshift({
      value: lang.lang('dataInfo.selectArea'),
      label: lang.lang('dataInfo.selectArea'),
    })
    this.addressArr = resultArr
  }
  //选择区域部分
  @action.bound
  async fetchChoseAreaData() {
    let startTime = Date.parse(this.oneDayAgo)
    let endTime = Date.parse(this.elevenDaysAgo)
    let str = ''
      //拿全部区域的信息
    if (this.choseAddress[0] === lang.lang('dataInfo.selectArea')) {
      str = `startTime=${startTime}&endTime=${endTime}&type=DAY&size=${this.pageSize}&page=${this.currentPage}`
    } else {
      //点击 数据明细中Input框筛选后获取 选中区域的信息
      if(UserInfoStore.accountUseNewRules){
        str = `startTime=${startTime}&endTime=${endTime}&type=DAY&size=${this.pageSize}&page=${this.currentPage}&regionId=${this.regionId}`
      }else{
        switch (this.choseAddress.length) {
          case 1:
            str = `startTime=${startTime}&endTime=${endTime}&type=DAY&size=${this.pageSize}&page=${this.currentPage}&province=${this.choseAddress[0]}`
            break
          case 2:
            str = `startTime=${startTime}&endTime=${endTime}&type=DAY&size=${this.pageSize}&page=${this.currentPage}&province=${this.choseAddress[0]}&city=${this.choseAddress[1]}`
            break
          case 3:
            str = `startTime=${startTime}&endTime=${endTime}&type=DAY&size=${this.pageSize}&page=${this.currentPage}&province=${this.choseAddress[0]}&city=${this.choseAddress[1]}&district=${this.choseAddress[2]}`
            break
        }
        
      }
    }

    try {
      let   getAreaCleanerceInfoFetchHandlerFin=UserInfoStore.accountUseNewRules?dateDetailsGetAreaCleanerceInfo(str):getAreaCleanerceInfoFetchHandler(str)

      let [cleanersRes] = await Promise.all([
        getAreaCleanerceInfoFetchHandlerFin
      ])
      if (cleanersRes.ok) {
        const resBody = await cleanersRes.json()
        this.fetchCleanersSuccess(resBody)
      }
    } catch (e) {}
  }
  @action fetchCleanersSuccess(data) {
    GlobalControlStore.showLoading = false
    this.timesArr = data.content.times
    this.areaArr = data.content.collects
    this.totalPage = data.content.totalPages
  }

  //创建Excel
  @action.bound
  async createExcel() {
    if (this.isDailyReport) {
      //天
      let start = this.exportDateTime[0].valueOf()
      let end = this.exportDateTime[1].valueOf()
      let res
      //有行政区的owner用户
      if (UserInfoStore.accountUseNewRules) {
        //默认为空，表示全部，请求query不用加行政id。否则，需要加选中行政id
        let str = `startTime=${start}&endTime=${end}&type=DAY`
        if(this.exportChoseAddressId!==''){
          str+=`&subordinate=${this.exportChoseAddressId}`
        }
        res = await createDistrictExcelFetchHandler(str)
      //没有行政区的owner用户
      } else {
        let obj
        if (this.exportChoseAddress[0] === lang.lang('dataInfo.selectArea')) {
          obj = {
            startTime: start,
            endTime: end,
            type: 'DAY',
          }
        } else {
          switch (this.exportChoseAddress.length) {
            case 3:
              obj = {
                province: this.exportChoseAddress[0],
                city: this.exportChoseAddress[1],
                district: this.exportChoseAddress[2],
                startTime: start,
                endTime: end,
                type: 'DAY',
              }
              break
            case 2:
              obj = {
                province: this.exportChoseAddress[0],
                city: this.exportChoseAddress[1],
                startTime: start,
                endTime: end,
                type: 'DAY',
              }
              break
            case 1:
              obj = {
                province: this.exportChoseAddress[0],
                startTime: start,
                endTime: end,
                type: 'DAY',
              }
              break
          }
        }
        res = await createExcelFetchHandler(obj)
      }
      if (res.ok) {
        const resBody = await res.json()
        this.createExcelSuccess(resBody)
      }
    } else {
      //月
      let start = this.exportMonthTime[0].valueOf()
      let end = this.exportMonthTime[1].valueOf()
      let res
      if (UserInfoStore.accountUseNewRules) {
        let str = `startTime=${start}&endTime=${end}&type=MONTH`
        if(this.exportChoseAddressId!==''){
          str+=`&subordinate=${this.exportChoseAddressId}`
        }
        res = await createDistrictExcelFetchHandler(str)
      } else {
        let obj
        if (this.exportChoseAddress[0] === lang.lang('dataInfo.selectArea')) {
          obj = {
            startTime: start,
            endTime: end,
            type: 'MONTH',
          }
        } else {
          switch (this.exportChoseAddress.length) {
            case 3:
              obj = {
                province: this.exportChoseAddress[0],
                city: this.exportChoseAddress[1],
                district: this.exportChoseAddress[2],
                startTime: start,
                endTime: end,
                type: 'MONTH',
              }
              break
            case 2:
              obj = {
                province: this.exportChoseAddress[0],
                city: this.exportChoseAddress[1],
                startTime: start,
                endTime: end,
                type: 'MONTH',
              }
              break
            case 1:
              obj = {
                province: this.exportChoseAddress[0],
                startTime: start,
                endTime: end,
                type: 'MONTH',
              }
              break
          }
        }
        res = await createExcelFetchHandler(obj)
      }
      if (res.ok) {
        const resBody = await res.json()
        this.createExcelSuccess(resBody)
      }
    }
  }
  @action createExcelSuccess(data) {
    console.log(data)
    let that = this
    this.exportDataName = data.content
    this.intervalTime = setInterval(function () {
      that.getIsExistFunction()
      if (that.progressNum <= 90) {
        that.progressNum += 20
      }
    }, 1000)
  }
  @action.bound
  async getIsExistFunction() {
    let res = await getIsExistExcel(this.exportDataName)
    if (res.ok) {
      const resBody = await res.json()
      this.getIsExistSuccess(resBody)
    } else {
      const resBody = await res.json()
      this.getIsExistFail(resBody)
    }
  }
  @action
  getIsExistSuccess(data) {
    if (data.content) {
      clearInterval(this.intervalTime)
      this.progressNum = 0
      this.progressIsShow = false
      this.exportTipsShow = true
      this.exportDataSuceess = true
      this.exportChoseAddress = ['全部']
      this.exportChoseAddressId = ''

    }
  }
  @action getIsExistFail(data) {
    clearInterval(this.intervalTime)
    if (data.code === 102) {
      this.exportTipsTxt = lang.lang('dataInfo.TipsPermissionErr')
      this.exportTipsShow = true
    } else if (data.code === 300101) {
      this.exportTipsTxt = lang.lang('dataInfo.TipsBuildFail')
      this.exportTipsShow = true
    } else {
      this.exportTipsTxt = lang.lang('dataInfo.TipsBuildFail')
      this.exportTipsShow = true
    }
  }
}

const DataDetailsStore = new Store()

export default DataDetailsStore



// WEBPACK FOOTER //
// ./src/store/DataDetailsStore.js